
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelAccountFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EX_COMM_ChannelAccount"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from_address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_host"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_port"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imap_encryption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smtp_host"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smtp_port"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smtp_username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smtp_encryption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oauth_client_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oauth_tenant_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providerConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_number_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"business_account_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticket_template_name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"is_active"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_validated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_faulty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_access_token"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validation_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validated_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pointsOfSale"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated_at"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":583}};
    doc.loc.source = {"body":"fragment ChannelAccountFields on EX_COMM_ChannelAccount {\n    id\n    channel\n    name\n    from_address\n    transport\n    imap_host\n    imap_port\n    imap_username\n    imap_encryption\n    smtp_host\n    smtp_port\n    smtp_username\n    smtp_encryption\n    oauth_client_id\n    oauth_tenant_id\n    providerConfig {\n        phone_number_id\n        business_account_id\n        ticket_template_name\n    }\n    is_active\n    is_validated\n    is_faulty\n    has_access_token\n    validation_status\n    validated_at\n    pointsOfSale {\n        id\n        name\n    }\n    created_at\n    updated_at\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ChannelAccountFields"] = oneQuery(doc, "ChannelAccountFields");
        
